import { createEvent, createStore } from 'effector';
import { KeycloakTokenParsed } from 'keycloak-js';
import { UserGroup } from '@/types/groups';

export interface User extends KeycloakTokenParsed {
  groups?: UserGroup[];
  email?: string;
  num?: string | null;
  given_name?: string;
  family_name?: string;
  name?: string;
}

export const setUser = createEvent<User>();
export const setToken = createEvent<string>();
export const resetUser = createEvent();

export const $user = createStore<User | null>(null)
  .on(setUser, (_, user) => user)
  .reset(resetUser);

export const $token = createStore<string | null>(null)
  .on(setToken, (_, token) => token)
  .reset(resetUser);
